import ja from 'date-fns/locale/ja'; // the locale you want
import moment from 'moment';
import { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // register it with the name you want
import images from 'src/common/images';
registerLocale('ja', ja);

interface DatePickerProps {
  handleChange: (arg: string) => void;
  value: string;
}

const DatetimePicker = ({ handleChange, value }: DatePickerProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const format = 'YYYY-MM-DD';

  const onChange = (value: Date) => {
    handleChange(moment(value).format(format));
    setIsOpen(false);
  };

  return (
    <div className="inline-block relative">
      <div className="rounded-[3px] min-w-[100px] flex items-center pl-2 mr-2 w-[180px] h-[56px] border">
        {moment(value).isValid() ? moment(value).format(format) : format}
        <img
          src={images.icCalendar}
          alt=""
          className={'w-[auto] h-[40%] ml-auto mr-2 '}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen && (
        <div className="absolute">
          <DatePicker
            locale="ja"
            selected={value ? moment(value).toDate() : moment().toDate()}
            onChange={onChange}
            inline
          />
        </div>
      )}
    </div>
  );
};

export default DatetimePicker;
